function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { extend } from "../../../shared/utils/extend.js";
import { Panzoom } from "../../../Panzoom/Panzoom.js";
var defaults = {
  // Class name for slide element indicating that content can be zoomed in
  canZoomInClass: "can-zoom_in",
  // Class name for slide element indicating that content can be zoomed out
  canZoomOutClass: "can-zoom_out",
  // Do zoom animation from thumbnail image when starting or closing fancybox
  zoom: true,
  // Animate opacity while zooming
  zoomOpacity: "auto",
  // "auto" | true | false,
  // Zoom animation friction
  zoomFriction: 0.82,
  // Disable zoom animation if thumbnail is visible only partly
  ignoreCoveredThumbnail: false,
  // Enable guestures
  touch: true,
  // Action to be performed when user clicks on the image
  click: "toggleZoom",
  // "toggleZoom" | "next" | "close" | null
  // Action to be performed when double-click event is detected on the image
  doubleClick: null,
  // "toggleZoom" | null
  // Action to be performed when user rotates a wheel button on a pointing device
  wheel: "zoom",
  // "zoom" | "slide" | "close" | null
  // How image should be resized to fit its container
  fit: "contain",
  // "contain" | "contain-w" | "cover"
  // Should create wrapping element around the image
  wrap: false,
  // Custom Panzoom options
  Panzoom: {
    ratio: 1
  }
};
export var Image = /*#__PURE__*/function () {
  function Image(fancybox) {
    _classCallCheck(this, Image);

    this.fancybox = fancybox;

    for (var _i = 0, _arr = [// Fancybox
    "onReady", "onClosing", "onDone", // Fancybox.Carousel
    "onPageChange", "onCreateSlide", "onRemoveSlide", // Image load/error
    "onImageStatusChange"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      this[methodName] = this[methodName].bind(this);
    }

    this.events = {
      ready: this.onReady,
      closing: this.onClosing,
      done: this.onDone,
      "Carousel.change": this.onPageChange,
      "Carousel.createSlide": this.onCreateSlide,
      "Carousel.removeSlide": this.onRemoveSlide
    };
  }
  /**
   * Handle `ready` event to start loading content
   */


  _createClass(Image, [{
    key: "onReady",
    value: function onReady() {
      var _this = this;

      this.fancybox.Carousel.slides.forEach(function (slide) {
        if (slide.$el) {
          _this.setContent(slide);
        }
      });
    }
    /**
     * Handle `done` event to update cursor
     * @param {Object} fancybox
     * @param {Object} slide
     */

  }, {
    key: "onDone",
    value: function onDone(fancybox, slide) {
      this.handleCursor(slide);
    }
    /**
     * Handle `closing` event to clean up all slides and to start zoom-out animation
     * @param {Object} fancybox
     */

  }, {
    key: "onClosing",
    value: function onClosing(fancybox) {
      clearTimeout(this.clickTimer);
      this.clickTimer = null; // Remove events

      fancybox.Carousel.slides.forEach(function (slide) {
        if (slide.$image) {
          slide.state = "destroy";
        }

        if (slide.Panzoom) {
          slide.Panzoom.detachEvents();
        }
      }); // If possible, start the zoom animation, it will interrupt the default closing process

      if (this.fancybox.state === "closing" && this.canZoom(fancybox.getSlide())) {
        this.zoomOut();
      }
    }
    /**
     * Process `Carousel.createSlide` event to create image content
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onCreateSlide",
    value: function onCreateSlide(fancybox, carousel, slide) {
      if (this.fancybox.state !== "ready") {
        return;
      }

      this.setContent(slide);
    }
    /**
     * Handle `Carousel.removeSlide` event to do clean up the slide
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onRemoveSlide",
    value: function onRemoveSlide(fancybox, carousel, slide) {
      if (slide.$image) {
        slide.$el.classList.remove(fancybox.option("Image.canZoomInClass"));
        slide.$image.remove();
        slide.$image = null;
      }

      if (slide.Panzoom) {
        slide.Panzoom.destroy();
        slide.Panzoom = null;
      }

      if (slide.$el && slide.$el.dataset) {
        delete slide.$el.dataset.imageFit;
      }
    }
    /**
     * Build DOM elements and add event listeners
     * @param {Object} slide
     */

  }, {
    key: "setContent",
    value: function setContent(slide) {
      var _this2 = this;

      // Check if this slide should contain an image
      if (slide.isDom || slide.html || slide.type && slide.type !== "image") {
        return;
      }

      if (slide.$image) {
        return;
      }

      slide.type = "image";
      slide.state = "loading"; // * Build layout
      // Container

      var $content = document.createElement("div");
      $content.style.visibility = "hidden"; // Image element

      var $image = document.createElement("img");
      $image.addEventListener("load", function (event) {
        event.stopImmediatePropagation();

        _this2.onImageStatusChange(slide);
      });
      $image.addEventListener("error", function () {
        _this2.onImageStatusChange(slide);
      });
      $image.src = slide.src;
      $image.alt = "";
      $image.draggable = false;
      $image.classList.add("fancybox__image");

      if (slide.srcset) {
        $image.setAttribute("srcset", slide.srcset);
      }

      if (slide.sizes) {
        $image.setAttribute("sizes", slide.sizes);
      }

      slide.$image = $image;
      var shouldWrap = this.fancybox.option("Image.wrap");

      if (shouldWrap) {
        var $wrap = document.createElement("div");
        $wrap.classList.add(typeof shouldWrap === "string" ? shouldWrap : "fancybox__image-wrap");
        $wrap.appendChild($image);
        $content.appendChild($wrap);
        slide.$wrap = $wrap;
      } else {
        $content.appendChild($image);
      } // Set data attribute if other that default
      // for example, set `[data-image-fit="contain-w"]`


      slide.$el.dataset.imageFit = this.fancybox.option("Image.fit"); // Append content

      this.fancybox.setContent(slide, $content); // Display loading icon

      if ($image.complete || $image.error) {
        this.onImageStatusChange(slide);
      } else {
        this.fancybox.showLoading(slide);
      }
    }
    /**
     * Handle image state change, display error or start revealing image
     * @param {Object} slide
     */

  }, {
    key: "onImageStatusChange",
    value: function onImageStatusChange(slide) {
      var _this3 = this;

      var $image = slide.$image;

      if (!$image || slide.state !== "loading") {
        return;
      }

      if (!($image.complete && $image.naturalWidth && $image.naturalHeight)) {
        this.fancybox.setError(slide, "{{IMAGE_ERROR}}");
        return;
      }

      this.fancybox.hideLoading(slide);

      if (this.fancybox.option("Image.fit") === "contain") {
        this.initSlidePanzoom(slide);
      } // Add `wheel` and `click` event handler


      slide.$el.addEventListener("wheel", function (event) {
        return _this3.onWheel(slide, event);
      }, {
        passive: false
      });
      slide.$content.addEventListener("click", function (event) {
        return _this3.onClick(slide, event);
      }, {
        passive: false
      });
      this.revealContent(slide);
    }
    /**
     * Make image zoomable and draggable using Panzoom
     * @param {Object} slide
     */

  }, {
    key: "initSlidePanzoom",
    value: function initSlidePanzoom(slide) {
      var _this4 = this;

      if (slide.Panzoom) {
        return;
      } //* Initialize Panzoom


      slide.Panzoom = new Panzoom(slide.$el, extend(true, this.fancybox.option("Image.Panzoom", {}), {
        viewport: slide.$wrap,
        content: slide.$image,
        wrapInner: false,
        // Allow to select caption text
        textSelection: true,
        // Toggle gestures
        touch: this.fancybox.option("Image.touch"),
        // This will prevent click conflict with fancybox main carousel
        panOnlyZoomed: true,
        // Disable default click / wheel events as custom event listeners will replace them,
        // because click and wheel events should work without Panzoom
        click: false,
        wheel: false
      }));
      slide.Panzoom.on("startAnimation", function () {
        _this4.fancybox.trigger("Image.startAnimation", slide);
      });
      slide.Panzoom.on("endAnimation", function () {
        if (slide.state === "zoomIn") {
          _this4.fancybox.done(slide);
        }

        _this4.handleCursor(slide);

        _this4.fancybox.trigger("Image.endAnimation", slide);
      });
      slide.Panzoom.on("afterUpdate", function () {
        _this4.handleCursor(slide);

        _this4.fancybox.trigger("Image.afterUpdate", slide);
      });
    }
    /**
     * Start zoom-in animation if possible, or simply reveal content
     * @param {Object} slide
     */

  }, {
    key: "revealContent",
    value: function revealContent(slide) {
      // Animate only on first run
      if (this.fancybox.Carousel.prevPage === null && slide.index === this.fancybox.options.startIndex && this.canZoom(slide)) {
        this.zoomIn();
      } else {
        this.fancybox.revealContent(slide);
      }
    }
    /**
     * Get zoom info for selected slide
     * @param {Object} slide
     */

  }, {
    key: "getZoomInfo",
    value: function getZoomInfo(slide) {
      var $thumb = slide.$thumb,
          thumbRect = $thumb.getBoundingClientRect(),
          thumbWidth = thumbRect.width,
          thumbHeight = thumbRect.height,
          //
      contentRect = slide.$content.getBoundingClientRect(),
          contentWidth = contentRect.width,
          contentHeight = contentRect.height,
          //
      shiftedTop = contentRect.top - thumbRect.top,
          shiftedLeft = contentRect.left - thumbRect.left; // Check if need to update opacity

      var opacity = this.fancybox.option("Image.zoomOpacity");

      if (opacity === "auto") {
        opacity = Math.abs(thumbWidth / thumbHeight - contentWidth / contentHeight) > 0.1;
      }

      return {
        top: shiftedTop,
        left: shiftedLeft,
        scale: thumbRect.width / contentWidth,
        opacity: opacity
      };
    }
    /**
     * Determine if it is possible to do zoom-in animation
     */

  }, {
    key: "canZoom",
    value: function canZoom(slide) {
      var fancybox = this.fancybox,
          $container = fancybox.$container;

      if (window.visualViewport && window.visualViewport.scale !== 1) {
        return false;
      }

      if (!fancybox.option("Image.zoom") || fancybox.option("Image.fit") !== "contain") {
        return false;
      }

      var $thumb = slide.$thumb;

      if (!$thumb || slide.state === "loading") {
        return false;
      } // * Check if thumbnail image is really visible


      $container.classList.add("fancybox__no-click");
      var rect = $thumb.getBoundingClientRect();
      var rez; // Check if thumbnail image is actually visible on the screen

      if (this.fancybox.option("Image.ignoreCoveredThumbnail")) {
        var visibleTopLeft = document.elementFromPoint(rect.left + 1, rect.top + 1) === $thumb;
        var visibleBottomRight = document.elementFromPoint(rect.right - 1, rect.bottom - 1) === $thumb;
        rez = visibleTopLeft && visibleBottomRight;
      } else {
        rez = document.elementFromPoint(rect.left + rect.width * 0.5, rect.top + rect.height * 0.5) === $thumb;
      }

      $container.classList.remove("fancybox__no-click");
      return rez;
    }
    /**
     * Perform zoom-in animation
     */

  }, {
    key: "zoomIn",
    value: function zoomIn() {
      var fancybox = this.fancybox,
          slide = fancybox.getSlide(),
          Panzoom = slide.Panzoom;

      var _this$getZoomInfo = this.getZoomInfo(slide),
          top = _this$getZoomInfo.top,
          left = _this$getZoomInfo.left,
          scale = _this$getZoomInfo.scale,
          opacity = _this$getZoomInfo.opacity;

      slide.state = "zoomIn";
      fancybox.trigger("reveal", slide); // Scale and move to start position

      Panzoom.panTo({
        x: left * -1,
        y: top * -1,
        scale: scale,
        friction: 0,
        ignoreBounds: true
      });
      slide.$content.style.visibility = "";

      if (opacity === true) {
        Panzoom.on("afterTransform", function (panzoom) {
          if (slide.state === "zoomIn" || slide.state === "zoomOut") {
            panzoom.$content.style.opacity = Math.min(1, 1 - (1 - panzoom.content.scale) / (1 - scale));
          }
        });
      } // Animate back to original position


      Panzoom.panTo({
        x: 0,
        y: 0,
        scale: 1,
        friction: this.fancybox.option("Image.zoomFriction")
      });
    }
    /**
     * Perform zoom-out animation
     */

  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var _this5 = this;

      var fancybox = this.fancybox,
          slide = fancybox.getSlide(),
          Panzoom = slide.Panzoom;

      if (!Panzoom) {
        return;
      }

      slide.state = "zoomOut";
      fancybox.state = "customClosing";

      if (slide.$caption) {
        slide.$caption.style.visibility = "hidden";
      }

      var friction = this.fancybox.option("Image.zoomFriction");

      var animatePosition = function animatePosition(event) {
        var _this5$getZoomInfo = _this5.getZoomInfo(slide),
            top = _this5$getZoomInfo.top,
            left = _this5$getZoomInfo.left,
            scale = _this5$getZoomInfo.scale,
            opacity = _this5$getZoomInfo.opacity; // Increase speed on the first run if opacity is not animated


        if (!event && !opacity) {
          friction *= 0.82;
        }

        Panzoom.panTo({
          x: left * -1,
          y: top * -1,
          scale: scale,
          friction: friction,
          ignoreBounds: true
        }); // Gradually increase speed

        friction *= 0.98;
      }; // Page scrolling will cause thumbnail to change position on the display,
      // therefore animation end position has to be recalculated after each page scroll


      window.addEventListener("scroll", animatePosition);
      Panzoom.once("endAnimation", function () {
        window.removeEventListener("scroll", animatePosition);
        fancybox.destroy();
      });
      animatePosition();
    }
    /**
     * Set the type of mouse cursor to indicate if content is zoomable
     * @param {Object} slide
     */

  }, {
    key: "handleCursor",
    value: function handleCursor(slide) {
      if (slide.type !== "image" || !slide.$el) {
        return;
      }

      var panzoom = slide.Panzoom;
      var clickAction = this.fancybox.option("Image.click", false, slide);
      var classList = slide.$el.classList;

      if (panzoom && clickAction === "toggleZoom") {
        var canZoom = panzoom && panzoom.content.scale === 1 && panzoom.option("maxScale") - panzoom.content.scale > 0.01;
        classList[canZoom ? "add" : "remove"](this.fancybox.option("Image.canZoomInClass"));
      } else if (clickAction === "close") {
        classList.add(this.fancybox.option("Image.canZoomOutClass"));
      }
    }
    /**
     * Handle `wheel` event
     * @param {Object} slide
     * @param {Object} event
     */

  }, {
    key: "onWheel",
    value: function onWheel(slide, event) {
      if (this.fancybox.state !== "ready") {
        return;
      }

      if (this.fancybox.trigger("Image.wheel", event) === false) {
        return;
      }

      switch (this.fancybox.option("Image.wheel")) {
        case "zoom":
          slide.Panzoom && slide.Panzoom.zoomWithWheel(event);
          break;

        case "close":
          this.fancybox.close();
          break;

        case "slide":
          this.fancybox[event.deltaY < 0 ? "prev" : "next"]();
          break;
      }
    }
    /**
     * Handle `click` and `dblclick` events
     * @param {Object} slide
     * @param {Object} event
     */

  }, {
    key: "onClick",
    value: function onClick(slide, event) {
      var _this6 = this;

      // Check that clicks should be allowed
      if (this.fancybox.state !== "ready") {
        return;
      }

      var panzoom = slide.Panzoom;

      if (panzoom && (panzoom.dragPosition.midPoint || panzoom.dragOffset.x !== 0 || panzoom.dragOffset.y !== 0 || panzoom.dragOffset.scale !== 1)) {
        return;
      }

      if (this.fancybox.Carousel.Panzoom.lockAxis) {
        return false;
      }

      var process = function process(action) {
        switch (action) {
          case "toggleZoom":
            event.stopPropagation();
            slide.Panzoom && slide.Panzoom.zoomWithClick(event);
            break;

          case "close":
            _this6.fancybox.close();

            break;

          case "next":
            event.stopPropagation();

            _this6.fancybox.next();

            break;
        }
      };

      var clickAction = this.fancybox.option("Image.click");
      var dblclickAction = this.fancybox.option("Image.doubleClick");

      if (dblclickAction) {
        if (this.clickTimer) {
          clearTimeout(this.clickTimer);
          this.clickTimer = null;
          process(dblclickAction);
        } else {
          this.clickTimer = setTimeout(function () {
            _this6.clickTimer = null;
            process(clickAction);
          }, 300);
        }
      } else {
        process(clickAction);
      }
    }
    /**
     * Handle `Carousel.change` event to reset zoom level for any zoomed in/out content
     * and to revel content of the current page
     * @param {Object} fancybox
     * @param {Object} carousel
     */

  }, {
    key: "onPageChange",
    value: function onPageChange(fancybox, carousel) {
      var currSlide = fancybox.getSlide();
      carousel.slides.forEach(function (slide) {
        if (!slide.Panzoom || slide.state !== "done") {
          return;
        }

        if (slide.index !== currSlide.index) {
          slide.Panzoom.panTo({
            x: 0,
            y: 0,
            scale: 1,
            friction: 0.8
          });
        }
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      this.fancybox.on(this.events);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.fancybox.off(this.events);
    }
  }]);

  return Image;
}(); // Expose defaults

Image.defaults = defaults;